import React from 'react'

interface SettingsIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const SettingsIcon: React.FC<SettingsIconProps> = ({
  color = '#000',
  gradient,
  width = 20,
  height = 21,
  alt = 'Settings icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 20 21'
      aria-label={alt}
    >
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M6.952.94c.08-.538.53-.94 1.086-.94h3.84c.537 0 1.014.382 1.098.94v.005l.312 2.2c.402.187.778.408 1.138.659l2.084-.838.018-.006c.457-.152 1.041-.012 1.33.5l1.923 3.33.005.01a1.12 1.12 0 01-.282 1.393l-.005.005-1.748 1.365c.021.216.032.437.032.662 0 .227-.01.446-.029.658l1.73 1.368c.451.344.545.94.284 1.41l-.005.009-1.918 3.32a1.1 1.1 0 01-1.358.49l-.006-.003-2.068-.831c-.354.246-.733.47-1.137.66l-.31 2.188c-.066.58-.562.956-1.088.956h-3.84c-.561 0-.991-.402-1.093-.91l-.004-.018-.313-2.216a7.598 7.598 0 01-1.139-.66l-2.084.838-.018.006c-.456.152-1.04.012-1.328-.5L.135 13.66l-.006-.01a1.12 1.12 0 01.282-1.393l.006-.005 1.748-1.365a5.89 5.89 0 01.009-1.327L.433 8.2a1.09 1.09 0 01-.286-1.41l.006-.01L2.07 3.46a1.1 1.1 0 011.358-.49l.007.003 2.068.831a7.84 7.84 0 011.137-.66L6.952.94zM16.5 11.5l-.023-.414c.034-.281.056-.568.056-.861a5.3 5.3 0 00-.064-.837l-.059-.364 2.217-1.732-1.795-3.108-2.59 1.041-.283-.215a6.406 6.406 0 00-1.477-.854l-.333-.136-.392-2.77H8.17l-.392 2.77-.332.136a6.595 6.595 0 00-1.48.856l-.281.213-2.59-1.041-1.794 3.108 2.216 1.732-.058.364c-.045.281-.076.57-.076.837 0 .282.022.573.064.837l.058.365-2.216 1.73 1.795 3.109 2.59-1.041.283.215c.465.354.945.637 1.477.854l.332.136.392 2.77h3.587l.392-2.77.333-.136a6.592 6.592 0 001.479-.856l.282-.213 2.589 1.041 1.795-3.109-1.905-1.506-.21-.151zM9.958 7.25a2.986 2.986 0 00-2.975 2.975A2.986 2.986 0 009.958 13.2a2.986 2.986 0 002.975-2.975A2.986 2.986 0 009.958 7.25zm-4.225 2.975C5.733 7.9 7.633 6 9.958 6c2.325 0 4.225 1.9 4.225 4.225 0 2.325-1.9 4.225-4.225 4.225a4.236 4.236 0 01-4.225-4.225z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default SettingsIcon
